

export const frontMatter = {
	sidebar_position: 1,
	license: 'republish',
	author: 'Jan van Steenbergen',
	last_update: {
		author: 'Google Translate'
	},
	origin: 'http://steen.free.fr/interslavic/slovianto1.html'
};
export const contentTitle = 'Ниво 1';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-sr-cyrl-docusaurus-plugin-content-docs-current-learn-simple-grammar-level-1-md-1a3.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Абецеда и изговор",
  "id": "абецеда-и-изговор",
  "level": 2
}, {
  "value": "Граматика",
  "id": "граматика",
  "level": 2
}, {
  "value": "Именице",
  "id": "именице",
  "level": 3
}, {
  "value": "Придеви",
  "id": "придеви",
  "level": 3
}, {
  "value": "Личне заменице",
  "id": "личне-заменице",
  "level": 3
}, {
  "value": "Присвојне заменице",
  "id": "присвојне-заменице",
  "level": 3
}, {
  "value": "Показне заменице",
  "id": "показне-заменице",
  "level": 3
}, {
  "value": "Релативне заменице",
  "id": "релативне-заменице",
  "level": 3
}, {
  "value": "Упитне и неодређене заменице",
  "id": "упитне-и-неодређене-заменице",
  "level": 3
}, {
  "value": "Прономинални прилози",
  "id": "прономинални-прилози",
  "level": 3
}, {
  "value": "Бројеви",
  "id": "бројеви",
  "level": 3
}, {
  "value": "Глаголи",
  "id": "глаголи",
  "level": 3
}, {
  "value": "Синтакса",
  "id": "синтакса",
  "level": 3
}, {
  "value": "Пример текста: У ресторану",
  "id": "пример-текста-у-ресторану",
  "level": 2
}, {
  "value": "Основни речник",
  "id": "основни-речник",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    abbr: "abbr",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    header: "header",
    li: "li",
    p: "p",
    span: "span",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection, MDSlovianto1, MDSlovianto2, MDSlovianto3, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  if (!MDSlovianto1) _missingMdxReference("MDSlovianto1", true);
  if (!MDSlovianto2) _missingMdxReference("MDSlovianto2", true);
  if (!MDSlovianto3) _missingMdxReference("MDSlovianto3", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "ниво-1",
        children: "Ниво 1"
      })
    }), "\n", _jsx(_components.h2, {
      id: "абецеда-и-изговор",
      children: "Абецеда и изговор"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), " се може писати латиничним писмом и ћириличним писмом, али ћемо се овде концентрисати на латинично писмо:"]
    }), "\n", _jsx(MDSlovianto1, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "а"
          }), " на енглеском ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["f", _jsx(_components.strong, {
              children: "a"
            }), "ther"]
          })]
        }), "\n", _jsx(_components.li, {
          children: "као на енглеском"
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "тс"
          }), " на енглеском „би", _jsx(_components.strong, {
            children: "тс"
          }), "”"]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "цх"
          }), " на енглеском „", _jsx(_components.strong, {
            children: "цх"
          }), "ур", _jsx(_components.strong, {
            children: "цх"
          }), "”"]
        }), "\n", _jsx(_components.li, {
          children: "као на енглеском"
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "ј"
          }), " на енглеском „", _jsx(_components.strong, {
            children: "Ј"
          }), "охн”"]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "е"
          }), " на енглеском „б", _jsx(_components.strong, {
            children: "е"
          }), "ст”"]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "ие"
          }), " на енглеском „", _jsx(_components.strong, {
            children: "ие"
          }), "т”"]
        }), "\n", _jsx(_components.li, {
          children: "као на енглеском"
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "г"
          }), " на енглеском „", _jsx(_components.strong, {
            children: "г"
          }), "оод”"]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "цх"
          }), " на шкотском „ло", _jsx(_components.strong, {
            children: "цх"
          }), "”"]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "еа"
          }), " на енглеском „б", _jsx(_components.strong, {
            children: "еа"
          }), "т”"]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "и"
          }), " на енглеском „", _jsx(_components.strong, {
            children: "и"
          }), "ард”"]
        }), "\n", _jsx(_components.li, {
          children: "као на енглеском, али без аспирације"
        }), "\n", _jsx(_components.li, {
          children: "као на енглеском"
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "ли"
          }), " на енглеском „мил", _jsx(_components.strong, {
            children: "ли"
          }), "он”"]
        }), "\n", _jsx(_components.li, {
          children: "као на енглеском"
        }), "\n", _jsx(_components.li, {
          children: "као на енглеском"
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "ни"
          }), " на енглеском „ца", _jsx(_components.strong, {
            children: "ни"
          }), "он”"]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "о"
          }), " на енглеском „", _jsx(_components.strong, {
            children: "о"
          }), "р”"]
        }), "\n", _jsx(_components.li, {
          children: "као на енглеском, али без аспирације"
        }), "\n", _jsxs(_components.li, {
          children: ["ваљано ", _jsx(_components.em, {
            children: "р"
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["окренуто р, праћено ", _jsx(_components.em, {
            children: "ие"
          }), " као на енглеском „", _jsx(_components.strong, {
            children: "ие"
          }), "т”"]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "с"
          }), " на енглеском „", _jsx(_components.strong, {
            children: "с"
          }), "пин”"]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "сх"
          }), " на енглеском „", _jsx(_components.strong, {
            children: "сх"
          }), "оп”"]
        }), "\n", _jsx(_components.li, {
          children: "као на енглеском, али без аспирације"
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "оо"
          }), " на енглеском „б", _jsx(_components.strong, {
            children: "оо"
          }), "к”"]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "в"
          }), " на енглеском „а", _jsx(_components.strong, {
            children: "в"
          }), "оид”"]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "и"
          }), " на енглеском „б", _jsx(_components.strong, {
            children: "и"
          }), "т”"]
        }), "\n", _jsx(_components.li, {
          children: "као на енглеском"
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.em, {
            children: "си"
          }), " на енглеском „ви", _jsx(_components.strong, {
            children: "си"
          }), "он”"]
        }), "\n"]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["У ", _jsx(_components.a, {
        href: "https://interslavic-dictionary.com",
        children: "Међусловенском речнику"
      }), " наћи ћете и друге знакове, попут ", _jsx(_components.code, {
        children: "ò"
      }), ", ", _jsx(_components.code, {
        children: "ų"
      }), ", ", _jsx(_components.code, {
        children: "å"
      }), "  или ", _jsx(_components.code, {
        children: "ť"
      }), ". Можете једноставно игнорисати дијакритичке знакове и читати их као ", _jsx(_components.code, {
        children: "o"
      }), ", ", _jsx(_components.code, {
        children: "u"
      }), ", ", _jsx(_components.code, {
        children: "a"
      }), ", ", _jsx(_components.code, {
        children: "t"
      }), "  итд. То важи и за ", _jsx(_components.code, {
        children: "ě"
      }), ". Једини знакови који држе своје дијакритике у латинском правопису су ", _jsx(_components.code, {
        children: "č"
      }), ", ", _jsx(_components.code, {
        children: "š"
      }), "  и ", _jsx(_components.code, {
        children: "ž"
      }), ". Ако сматрате да је њихово писање незгодно, увек можете користити ", _jsx(_components.code, {
        children: "cz"
      }), ", ", _jsx(_components.code, {
        children: "sz"
      }), "  и ", _jsx(_components.code, {
        children: "zs"
      }), " (или ", _jsx(_components.code, {
        children: "cx"
      }), ", ", _jsx(_components.code, {
        children: "sx"
      }), "  и ", _jsx(_components.code, {
        children: "zx"
      }), ") као алтернативу."]
    }), "\n", _jsx(_components.p, {
      children: "Акцентуација је прилично бесплатна. Оно што је важније је да говорите полако и јасно. Као општа смерница, заслужује препоруку да се нагласак стави на претпоследњи слог."
    }), "\n", _jsx(_components.h2, {
      id: "граматика",
      children: "Граматика"
    }), "\n", _jsx(_components.h3, {
      id: "именице",
      children: "Именице"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Именице се могу завршавати на сугласник или ", _jsx(_components.code, {
          children: "-a"
        }), ", ", _jsx(_components.code, {
          children: "-o"
        }), ", ", _jsx(_components.code, {
          children: "-e"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "Slovianto"
        }), " нема чланке. Стога, ", _jsx(TransliteratorElement, {
          children: "žena"
        }), " може значити „жена” или „жена”."]
      }), "\n", _jsxs(_components.li, {
        children: ["Множина се формира додавањем ", _jsx(_components.code, {
          children: "-i"
        }), " ако се реч завршава на сугласник или заменом последњег самогласника са ", _jsx(_components.strong, {
          children: "-и"
        }), ":", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "muž"
            }), " „човек” → ", _jsx(TransliteratorElement, {
              children: "muži"
            }), " „али”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "žena"
            }), " „жена” → ", _jsx(TransliteratorElement, {
              children: "ženi"
            }), " „жене”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "slovo"
            }), " „речи” → ", _jsx(TransliteratorElement, {
              children: "slovi"
            }), " „речи”"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "придеви",
      children: "Придеви"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Придеви обично имају завршетак ", _jsx(_components.code, {
            children: "-y"
          }), " или ", _jsx(_components.code, {
            children: "-i"
          }), ". Они нису флективни и треба их ставити испред именице."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Придев се може претворити у прилог заменом ", _jsx(_components.code, {
            children: "-y"
          }), " са завршетком ", _jsx(_components.code, {
            children: "-o"
          }), ":"]
        }), "\n", _jsxs(_components.p, {
          children: [_jsx(TransliteratorElement, {
            children: "dobry"
          }), " „добро” → ", _jsx(TransliteratorElement, {
            children: "dobro"
          }), " „добро”"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Придеви се пореде помоћу речи ", _jsx(TransliteratorElement, {
            children: "vyše"
          }), " („више”), ", _jsx(TransliteratorElement, {
            children: "menje"
          }), " („мање”), ", _jsx(TransliteratorElement, {
            children: "naj-"
          }), " („највише”) и ", _jsx(TransliteratorElement, {
            children: "najmenje"
          }), " („најмање”):"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "dobry"
            }), " „добро”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "vyše dobry"
            }), " „боље”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "naj-dobry"
            }), " „најбоље”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "menje dobry"
            }), " „мање добро”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "najmenje dobry"
            }), " „најмање добро”"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "личне-заменице",
      children: "Личне заменице"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["За разлику од именица, личне заменице у ", _jsx(_components.span, {
            className: "notranslate",
            translate: "no",
            children: "Slovianto"
          }), " разликују ", _jsx(_components.em, {
            children: "номинатив"
          }), " (субјекат реченице, агенс) и ", _jsx(_components.em, {
            children: "акузатив"
          }), " (објекат, пацијент)."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Облици субјекта су: ", _jsx(TransliteratorElement, {
            children: "ja"
          }), " „ја\", ", _jsx(TransliteratorElement, {
            children: "ty"
          }), " „ти (", _jsx(_components.abbr, {
            title: "једнина",
            children: "јед."
          }), ")\", ", _jsx(TransliteratorElement, {
            children: "on"
          }), " „он\", ", _jsx(TransliteratorElement, {
            children: "ona"
          }), " „она\", ", _jsx(TransliteratorElement, {
            children: "my"
          }), " „ми\", ", _jsx(TransliteratorElement, {
            children: "vy"
          }), " „ви (", _jsx(_components.abbr, {
            title: "множина",
            children: "мн."
          }), ")\", ", _jsx(TransliteratorElement, {
            children: "oni"
          }), " „они\"."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Облици објекта су: ", _jsx(TransliteratorElement, {
            children: "mene"
          }), " „мене\", ", _jsx(TransliteratorElement, {
            children: "tebe"
          }), " „тебе (", _jsx(_components.abbr, {
            title: "једнина",
            children: "јед."
          }), ")\", ", _jsx(TransliteratorElement, {
            children: "jego"
          }), " „њега\", ", _jsx(TransliteratorElement, {
            children: "ju"
          }), " „њу\", ", _jsx(TransliteratorElement, {
            children: "nas"
          }), " „нас\", ", _jsx(TransliteratorElement, {
            children: "vas"
          }), " „вас (", _jsx(_components.abbr, {
            title: "множина",
            children: "мн."
          }), ")\", ", _jsx(TransliteratorElement, {
            children: "jih"
          }), " „њих\"."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Као и већина природних словенских језика, међусловенски има Т-В дистинкцију, односно ", _jsx(TransliteratorElement, {
            children: "vy"
          }), " и ", _jsx(TransliteratorElement, {
            children: "vas"
          }), " се користе не само за друго лице множине, већ и као учтив облик у једнини. ", _jsx(TransliteratorElement, {
            children: "Ty"
          }), "/", _jsx(TransliteratorElement, {
            children: "tebe"
          }), "  се користе за обраћање пријатељима, рођацима и деци."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.span, {
            className: "notranslate",
            translate: "no",
            children: "Slovianto"
          }), " такође има повратну заменицу, ", _jsx(TransliteratorElement, {
            children: "se"
          }), ", што значи „себе, себе, себе, ...“. Она нема облик субјекта, само облик објекта."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Ова повратна заменица се може користити и као повратна заменица. ", _jsx(TransliteratorElement, {
            children: "Oni myt se"
          }), " значи: „они се перу“, али може значити и: „они се перу“."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "После предлога увек следи акузатив:"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "s mene"
            }), " „са мном”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "bez jego"
            }), " „без њега”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "za tebe"
            }), " „иза тебе”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["За ", _jsx(_components.em, {
            children: "индиректни објекат"
          }), " може се додати предлог ", _jsx(_components.code, {
            children: "k"
          }), " „за, према”:"]
        }), "\n", _jsxs(_components.p, {
          children: [_jsx(TransliteratorElement, {
            children: "Dajte k mene ..."
          }), " „Дај ми...”"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "присвојне-заменице",
      children: "Присвојне заменице"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Присвојне заменице су: ", _jsx(TransliteratorElement, {
          children: "moj"
        }), " „мој”, ", _jsx(TransliteratorElement, {
          children: "tvoj"
        }), " „твој, твој”, ", _jsx(TransliteratorElement, {
          children: "jego"
        }), " „његов, његов”, ", _jsx(TransliteratorElement, {
          children: "jej"
        }), " „она”, ", _jsx(TransliteratorElement, {
          children: "naš"
        }), " „наш”, ", _jsx(TransliteratorElement, {
          children: "vaš"
        }), " „твој (", _jsx(_components.abbr, {
          title: "множина",
          children: "мн."
        }), ")”, ", _jsx(TransliteratorElement, {
          children: "jih"
        }), " „њихов”. Као и придеви, присвојне заменице се не склањају."]
      }), "\n", _jsxs(_components.li, {
        children: ["Ако је и поседник субјекат реченице, рефлексив ", _jsx(TransliteratorElement, {
          children: "svoj"
        }), " „свој” се користи за сва лица."]
      }), "\n", _jsxs(_components.li, {
        children: ["Постоје и упитне и неодређене присвојне заменице, попут ", _jsx(TransliteratorElement, {
          children: "čij"
        }), " „чији”, ", _jsx(TransliteratorElement, {
          children: "ničij"
        }), " „ничији”, ", _jsx(TransliteratorElement, {
          children: "něčij"
        }), " „нечији”, ", _jsx(TransliteratorElement, {
          children: "čij-koli"
        }), " „билочији”."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "показне-заменице",
      children: "Показне заменице"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Показна заменица је ", _jsx(TransliteratorElement, {
          children: "toj"
        }), " „ово, оно, ови, они“."]
      }), "\n", _jsxs(_components.li, {
        children: ["Кад год је потребно направити разлику између ", _jsx(_components.em, {
          children: "овде"
        }), " и ", _jsx(_components.em, {
          children: "тамо"
        }), ", претходимо јој ", _jsx(_components.code, {
          children: "tu-"
        }), " „овде” или ", _jsx(_components.code, {
          children: "tam-"
        }), " „тамо”: ", _jsx(TransliteratorElement, {
          children: "tutoj"
        }), " „ово, ово”, ", _jsx(TransliteratorElement, {
          children: "tamtoj"
        }), " „оно, оно” ."]
      }), "\n", _jsxs(_components.li, {
        children: ["Када се користи независно, користите ", _jsx(TransliteratorElement, {
          children: "to"
        }), ":", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Čto jest to?"
            }), " „Шта је ово?”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "To jest kniga."
            }), " „Ово је књига.“"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "релативне-заменице",
      children: "Релативне заменице"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["У поједностављеном језику као што је ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "Slovianto"
        }), ", боље је избегавати подређене реченице. Али ако вам је ипак потребна релативна заменица, користите ", _jsx(TransliteratorElement, {
          children: "ktory"
        }), " „који“."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "упитне-и-неодређене-заменице",
      children: "Упитне и неодређене заменице"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Постоје две основне заменице: ", _jsx(TransliteratorElement, {
          children: "kto"
        }), " „ко” и ", _jsx(TransliteratorElement, {
          children: "čto"
        }), " „шта”. Баш као и личне заменице, ", _jsx(TransliteratorElement, {
          children: "kto"
        }), " има акузатив ", _jsx(TransliteratorElement, {
          children: "kogo"
        }), " за директни објекат."]
      }), "\n", _jsxs(_components.li, {
        children: ["Од ових је изведено и неколико неодређених заменица, нпр. ", _jsx(TransliteratorElement, {
          children: "někto"
        }), " „неко”, ", _jsx(TransliteratorElement, {
          children: "kto-koli"
        }), " „било ко”, ", _jsx(TransliteratorElement, {
          children: "ničto"
        }), " „ништа”, ", _jsx(TransliteratorElement, {
          children: "vsečto"
        }), " „све” (погледајте следећи одељак)."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "прономинални-прилози",
      children: "Прономинални прилози"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Сваки језик има посебну категорију међусобно повезаних заменица, прилога и придева, тзв. ", _jsx(_components.code, {
          children: "correlatives"
        }), ". Укратко, ово су упитне речи и речи које се користе да дају општи одговор на ова питања. У енглеском, као и многим другим језицима, ове речи су повезане једна са другом на прилично предвидљив начин (на пример: ", _jsx(_components.em, {
          children: "вхере/хере/тхере/сомевхере/анивхере/нигде/свуда, одакле/одатле/отуда, итд.)"
        }), " . Ово је случај и са ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "Slovianto"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Речи питања обично почињу са ", _jsx(_components.code, {
          children: "k-"
        }), ": ", _jsx(TransliteratorElement, {
          children: "kto"
        }), " „ко”, ", _jsx(TransliteratorElement, {
          children: "kogda"
        }), " „када”, ", _jsx(TransliteratorElement, {
          children: "kde"
        }), " „где”, ", _jsx(TransliteratorElement, {
          children: "ktory"
        }), " „који”, ", _jsx(TransliteratorElement, {
          children: "koliko"
        }), " „колико”"]
      }), "\n", _jsxs(_components.li, {
        children: ["Ако је одговор конкретна ствар, место итд., реч почиње са ", _jsx(_components.code, {
          children: "t-"
        }), ": ", _jsx(TransliteratorElement, {
          children: "to"
        }), " „ово, оно”, ", _jsx(TransliteratorElement, {
          children: "togda"
        }), " „онда”, ", _jsx(TransliteratorElement, {
          children: "toliko"
        }), " „ово много”"]
      }), "\n", _jsxs(_components.li, {
        children: ["Ако је одговор нешто непознато или неодређено, реч почиње са ", _jsx(_components.code, {
          children: "ně-"
        }), " (после упитном речју): ", _jsx(TransliteratorElement, {
          children: "někto"
        }), " „неко”, ", _jsx(TransliteratorElement, {
          children: "někogda"
        }), " „некад, једног дана”, ", _jsx(TransliteratorElement, {
          children: "někde"
        }), " „негде, негде”"]
      }), "\n", _jsxs(_components.li, {
        children: ["Ако је одговор негативан, реч почиње са ", _jsx(_components.code, {
          children: "ni-"
        }), " (прати речју питања): ", _jsx(TransliteratorElement, {
          children: "nikto"
        }), " „нико”, ", _jsx(TransliteratorElement, {
          children: "nikogda"
        }), " „никад”, ", _jsx(TransliteratorElement, {
          children: "nikde"
        }), " „нигде”"]
      }), "\n", _jsxs(_components.li, {
        children: ["Ако је одговор нешто неважно, реч се завршава са ", _jsx(_components.code, {
          children: "-koli"
        }), ", додато уз упитну реч: ", _jsx(TransliteratorElement, {
          children: "kto-koli"
        }), " „било ко”, ", _jsx(TransliteratorElement, {
          children: "kogda-koli"
        }), " „било када, кад год”, ", _jsx(TransliteratorElement, {
          children: "kde-koli"
        }), " „било где, било где”"]
      }), "\n", _jsxs(_components.li, {
        children: ["Ако је одговор свеобухватан, реч почиње са ", _jsx(_components.code, {
          children: "vse-"
        }), " или ", _jsx(_components.code, {
          children: "ves-"
        }), ": ", _jsx(TransliteratorElement, {
          children: "vsegda"
        }), " „увек”, ", _jsx(TransliteratorElement, {
          children: "vesde"
        }), " „свуда”"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "бројеви",
      children: "Бројеви"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.em, {
            children: "Кардинални бројеви"
          }), " од 1-10 су:"]
        }), "\n", _jsxs(_components.p, {
          children: ["1 – ", _jsx(TransliteratorElement, {
            children: "jedin"
          }), ", 2 – ", _jsx(TransliteratorElement, {
            children: "dva"
          }), ", 3 – ", _jsx(TransliteratorElement, {
            children: "tri"
          }), ", 4 – ", _jsx(TransliteratorElement, {
            children: "četyri"
          }), ", 5 – ", _jsx(TransliteratorElement, {
            children: "pet"
          }), ", 6 – ", _jsx(TransliteratorElement, {
            children: "šest"
          }), ", 7 – ", _jsx(TransliteratorElement, {
            children: "sedm"
          }), ", 8 – ", _jsx(TransliteratorElement, {
            children: "osm"
          }), ", 9 – ", _jsx(TransliteratorElement, {
            children: "devet"
          }), ", 10 – ", _jsx(TransliteratorElement, {
            children: "deset"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["„-тинејџери” (11-19) се формирају додавањем ", _jsx(_components.code, {
            children: "-nadset"
          }), ":"]
        }), "\n", _jsxs(_components.p, {
          children: ["11 – ", _jsx(TransliteratorElement, {
            children: "jedinnadset"
          }), ", 12 – ", _jsx(TransliteratorElement, {
            children: "dvanadset"
          }), ", ..."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["„-везе” (20, 30 ... 90) се формирају додавањем ", _jsx(_components.code, {
            children: "-deset"
          }), ":"]
        }), "\n", _jsxs(_components.p, {
          children: ["20 – ", _jsx(TransliteratorElement, {
            children: "dvadeset"
          }), ", 30 – ", _jsx(TransliteratorElement, {
            children: "trideset"
          }), ", ..."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["„-стотине” (200, 300 ... 900) се формирају додавањем ", _jsx(_components.code, {
            children: "-sto"
          }), ":"]
        }), "\n", _jsxs(_components.p, {
          children: ["200 – ", _jsx(TransliteratorElement, {
            children: "dvasto"
          }), ", 300 – ", _jsx(TransliteratorElement, {
            children: "tristo"
          }), ", ..."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Већи бројеви:"
        }), "\n", _jsxs(_components.p, {
          children: ["1.000 – ", _jsx(TransliteratorElement, {
            children: "tyseč"
          }), ", 1.000.000 – ", _jsx(TransliteratorElement, {
            children: "milion"
          }), ", 1.000.000.000 – ", _jsx(TransliteratorElement, {
            children: "miliard"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Комбинације ових се увек праве од високог ка ниском:"
        }), "\n", _jsxs(_components.p, {
          children: ["5,678 – ", _jsx(TransliteratorElement, {
            children: "pet-tyseč šeststo sedmdeset osm"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.em, {
            children: "Редни бројеви"
          }), " се формирају додавањем ", _jsx(_components.code, {
            children: "-y"
          }), " одговарајућем кардиналном броју, осим следећег:"]
        }), "\n", _jsxs(_components.p, {
          children: ["1. – ", _jsx(TransliteratorElement, {
            children: "prvy"
          }), ", 2. – ", _jsx(TransliteratorElement, {
            children: "drugy"
          }), ", 3. – ", _jsx(TransliteratorElement, {
            children: "tretji"
          }), ", 4. – ", _jsx(TransliteratorElement, {
            children: "četvrty"
          }), ", 100. – ", _jsx(TransliteratorElement, {
            children: "sotny"
          }), " или ", _jsx(TransliteratorElement, {
            children: "stoty"
          }), ", 1000. – ", _jsx(TransliteratorElement, {
            children: "tysečny"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "глаголи",
      children: "Глаголи"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Сви глаголи имају ", _jsx(_components.em, {
            children: "инфинитив"
          }), " завршетак ", _jsx(_components.code, {
            children: "-ti"
          }), ":"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "dělati"
            }), " „урадити”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "prositi"
            }), " „питати”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "nesti"
            }), " „носити”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.em, {
            children: "стем"
          }), " се добија уклањањем завршетка ", _jsx(_components.code, {
            children: "-ti"
          }), " из инфинитива:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(TransliteratorElement, {
              children: "děla-"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(TransliteratorElement, {
              children: "prosi-"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(TransliteratorElement, {
              children: "nes-"
            })
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["У овој раној фази, један завршетак за ", _jsx(_components.em, {
            children: "садашње време"
          }), " ће бити довољан. Формира се додавањем ", _jsx(_components.code, {
            children: "-t"
          }), " стабљици. Ако се основа садашњег времена завршава на сугласник, ", _jsx(_components.code, {
            children: "-e-"
          }), " се убацује између основе и завршетка:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "ja děla-t"
            }), " „Ја“"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "vy prosi-t"
            }), " „питаш”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "oni nes-et"
            }), " „они носе”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["А ево и једне неправилности која се толико често дешава у словенском да бисте могли да је научите сада: ако се основа завршава на ", _jsx(_components.code, {
            children: "k"
          }), " или ", _jsx(_components.code, {
            children: "g"
          }), ", ови сугласници постају ", _jsx(_components.code, {
            children: "č"
          }), " и ", _jsx(_components.code, {
            children: "ž"
          }), " испред уметнутог ", _jsx(_components.code, {
            children: "e"
          }), ":"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "pekti"
            }), " „испећи” → ", _jsx(TransliteratorElement, {
              children: "pečet"
            })]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "mogti"
            }), " „може” → ", _jsx(TransliteratorElement, {
              children: "možet"
            })]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["За ", _jsx(_components.em, {
            children: "прошло време"
          }), ", додајте ", _jsx(_components.code, {
            children: "-l"
          }), " (једнина) или ", _jsx(_components.code, {
            children: "-li"
          }), " (множина) у корен:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "ja děla-l"
            }), " „Јесам, урадио сам”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "on prosi-l"
            }), " „питао је”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "my nes-li"
            }), " „носили смо”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["За ", _jsx(_components.em, {
            children: "будуће време"
          }), ", користите ", _jsx(_components.code, {
            children: "bude"
          }), " са инфинитивом:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "ja bude dělati"
            }), " „Ја ћу”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "my bude prositi"
            }), " „питаћемо”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "oni bude nesti"
            }), " „они ће носити”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.em, {
            children: "услов"
          }), " се формира коришћењем честице ", _jsx(TransliteratorElement, {
            children: "by"
          }), " са прошлим временом:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "ja by dělal"
            }), " „Урадио бих/учинио бих”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.em, {
            children: "Императив"
          }), " има завршетак ", _jsx(_components.code, {
            children: "-jte"
          }), " после самогласника или ", _jsx(_components.code, {
            children: "-ite"
          }), " после сугласника:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "děla-jte"
            }), " „уради!”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "prosi-jte"
            }), " „питај!”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "nes-ite"
            }), " „носи!“"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.em, {
            children: "Пасив прошли"
          }), " настаје додавањем ", _jsx(_components.code, {
            children: "-ny"
          }), " корену. Ако се основа завршава на сугласник, уметните ", _jsx(_components.code, {
            children: "-e-"
          }), " између основе и завршетка. Ако се стуб завршава на ", _jsx(_components.code, {
            children: "-i-"
          }), ", убаците ", _jsx(_components.code, {
            children: "-e-"
          }), " и промените резултујући ", _jsx(_components.code, {
            children: "-ieny"
          }), " у ", _jsx(_components.code, {
            children: "-jeny"
          }), ":"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "děla-ny"
            }), " „готово”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "nes-eny"
            }), " „ношен”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "prosi-eny"
            }), " → ", _jsx(TransliteratorElement, {
              children: "prosjeny"
            }), " „питано”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Глагол ", _jsx(TransliteratorElement, {
            children: "byti"
          }), " „бити” је неправилан:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["садашње време: ", _jsx(TransliteratorElement, {
              children: "jest"
            })]
          }), "\n", _jsxs(_components.li, {
            children: ["прошло време: ", _jsx(TransliteratorElement, {
              children: "byl"
            }), ", ", _jsx(TransliteratorElement, {
              children: "byli"
            })]
          }), "\n", _jsxs(_components.li, {
            children: ["будуће време: ", _jsx(TransliteratorElement, {
              children: "bude"
            })]
          }), "\n", _jsxs(_components.li, {
            children: ["условно: ", _jsx(TransliteratorElement, {
              children: "byl by, byli by"
            })]
          }), "\n", _jsxs(_components.li, {
            children: ["императив: ", _jsx(TransliteratorElement, {
              children: "budite"
            })]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.em, {
            children: "Пасивни глас"
          }), " настаје као на енглеском, комбиновањем облика глагола ", _jsx(TransliteratorElement, {
            children: "byti"
          }), " „бити” са пасивним партиципом у прошлом:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "ja jest neseny"
            }), " „Носе ме”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "ja byl neseny"
            }), " „Носили су ме, носили су ме” итд."]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "синтакса",
      children: "Синтакса"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Преферирани ред речи је субјекат – глагол – објекат, као на енглеском. Није обавезно, али било који други ред речи може лако учинити реченицу нејасном или двосмисленом."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Придеви, присвојне заменице и слично се пожељно стављају испред именице коју модификују:"
        }), "\n", _jsxs(_components.p, {
          children: [_jsx(TransliteratorElement, {
            children: "toj dobry kniga"
          }), " „ова добра књига”"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Питања да-не разликују се од нормалних индикативних реченица само по интонацији:"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Otec kupil kniga"
            }), " „Отац је купио књигу.”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Otec kupil kniga?"
            }), " „Да ли је отац купио књигу?“"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "У осталим питањима упитна заменица или прилог долази на првом месту:"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Kaky kniga kupil otec?"
            }), " „Какву књигу је отац купио?“"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Kde otec kupil toj kniga?"
            }), " „Где је отац купио ту књигу?“"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Најлакши начин за изражавање поседовања је једноставно стављање поседника испред поседнутог. Када ово није довољно јасно, користите предлог ", _jsx(_components.code, {
            children: "od"
          }), " „од, од”:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "moj otec kniga"
            }), " „књига мог оца” (букв. „књига мог оца”)"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "kniga od moj otec"
            }), " „књига мог оца” (букв. „књига мог оца”)"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Исто тако, не морате да користите никакве посебне додатке за индиректни објекат. Кад год ово није довољно јасно, користите предлог ", _jsx(_components.code, {
            children: "k"
          }), " „за”:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Dajte moj otec toj kniga."
            }), " „Дај ту књигу мом оцу.”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Dajte toj kniga k moj otec."
            }), " „Дај ту књигу мом оцу.”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Да бисте изразили инструмент који се користи за нешто, користите предлог ", _jsx(_components.code, {
            children: "s"
          }), " „са”:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Ja udaril svoj otec s toj kniga."
            }), " „Ударио сам оца том књигом.“"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "пример-текста-у-ресторану",
      children: "Пример текста: У ресторану"
    }), "\n", _jsx(MDSlovianto2, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Добар дан! Да ли је ресторан отворен?"
        }), "\n", _jsx(_components.li, {
          children: "Добар дан. Да, отворени смо."
        }), "\n", _jsx(_components.li, {
          children: "Може ли се овде нешто попити?"
        }), "\n", _jsx(_components.li, {
          children: "Наравно, шта да ти донесем?"
        }), "\n", _jsx(_components.li, {
          children: "Шта имаш?"
        }), "\n", _jsx(_components.li, {
          children: "Чај, кафа, пиво, вино, вотка..."
        }), "\n", _jsx(_components.li, {
          children: "Имаш ли и ти нешто хладно?"
        }), "\n", _jsx(_components.li, {
          children: "Да, имамо сок, воду, млеко..."
        }), "\n", _jsx(_components.li, {
          children: "Онда, молим те, дај нам два сока."
        }), "\n", _jsx(_components.li, {
          children: "Два сока, ок. Да ли би и ти нешто појео?"
        }), "\n", _jsx(_components.li, {
          children: "Можда... Имаш ли хлеба?"
        }), "\n", _jsx(_components.li, {
          children: "Да наравно. Хлеб, месо, риба, све има."
        }), "\n", _jsx(_components.li, {
          children: "Хвала, само дај са путером, молим."
        }), "\n"]
      })
    }), "\n", _jsx(_components.h2, {
      id: "основни-речник",
      children: "Основни речник"
    }), "\n", _jsx(MDSlovianto3, {}), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

